import {Component, Inject, OnInit} from '@angular/core';
import {Language, LanguagesService} from 'src/app/services/languages.service';
import {AppStorageEnum} from 'src/app/models/storage.enum';
import {LANG_SET} from 'src/app/helpers';

@Component({
    selector: 'app-lang-switcher',
    templateUrl: './lang-switcher.component.html',
    standalone: false
})
export class LangSwitcherComponent implements OnInit {
  public languages: any[];

  constructor(
      private langService: LanguagesService,
      @Inject(LANG_SET) private langList: Language[],
  ) { }

  ngOnInit() {
      this.languages = this.langList.map(item => {
          return {
              code: item.id,
              name: item.name,
          };
      });
  }

    public getLang(): string {
        return localStorage.getItem(AppStorageEnum.storeLanguage);
    }

  public updateActiveLang(lang: string, event) {
      event.preventDefault();
      this.langService.setCurrentLang(lang);
  }

}
